<template>
  <div id="application-comments">
    <v-card>
      <v-card-title>
        <h4>Commentaires</h4>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-list subheader three-line>
          <div v-if="!$store.getters['moduleUser/userIsResponsible']">
            <v-textarea v-model="newComment.text" label="Ajouter un commentaire..." box></v-textarea>
            <v-checkbox
              v-model="newComment.isPrivate"
              label="Commentaire privé"
              color="primary"
              class="ma-0 pa-0"
            ></v-checkbox>
            <v-btn block color="primary" @click="comment">Ajouter</v-btn>
            <v-divider></v-divider>
          </div>
          <v-subheader v-if="!$store.getters['moduleUser/userIsResponsible']">Commentaires publics</v-subheader>
          <h4 class="text-xs-center">
            <small
              class="text-xs-center"
              v-if="$store.state.moduleApplications.currentApplication.comments.public == 0"
            >
              <i>Pas de commentaires</i>
            </small>
          </h4>
          <applicationCommentItem
            v-for="comment in $store.getters['moduleApplications/getSortedPublicComments']"
            :comment="comment"
            :key="comment.comment_id"
          ></applicationCommentItem>
        </v-list>
        <v-list subheader three-line v-if="!$store.getters['moduleUser/userIsResponsible']">
          <v-subheader>Vos commentaires privés</v-subheader>
          <h4 class="text-xs-center">
            <small
              class="text-xs-center"
              v-if="$store.state.moduleApplications.currentApplication.comments.private == 0"
            >
              <i>Pas de commentaires</i>
            </small>
          </h4>
          <applicationCommentItem
            v-for="comment in $store.getters['moduleApplications/getSortedPrivateComments']"
            :comment="comment"
            :key="comment.comment_id"
          ></applicationCommentItem>
        </v-list>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import applicationCommentItem from '@/components/application/applicationCommentItem.vue'
export default {
  name: 'application-comments',
  data() {
    return {
      newComment: {
        text: '',
        isPrivate: false
      }
    }
  },
  methods: {
    comment() {
      this.$store.dispatch('moduleApplications/addComment', { content: this.newComment.text, is_private: this.newComment.isPrivate, applicant_id: this.$store.state.moduleApplications.currentApplication.application_data.personal_data.applicant_id })
        .then(() => {
          this.$store.dispatch('moduleApplications/getCurrentApplicationComments', { id: this.$store.state.moduleApplications.currentApplication.application_data.personal_data.applicant_id })
          this.newComment.text = ''
          this.newComment.isPrivate = false
        })
    }
  },
  components: {
    applicationCommentItem
  }
}
</script>
